"use client";

import { createContext } from "react";

import { TVSeriesPagePreloadData } from "../types/tv-series-page-preload-data";

export const TVSeriesPagePreloadContext =
  createContext<TVSeriesPagePreloadData>({
    tmdbTVSeries: null,
  });
